import axios from "axios";
import { IAPIResponse } from "../../types/IAPIResponse";
import { IOption } from "../../types/Codes/IOptions";
import {
  ApplicationSMSTempletes,
  NewSmsTempleteDto,
  SmsTempleteDto,
} from "../types/SMSTempletes";

export class SMSTempletesAPI {
  async GetAllTempletes(registrar: boolean): Promise<IAPIResponse<IOption[]>> {
    const response = await axios.get<IAPIResponse>(
      "/admin/templates/sms/getAllTempletes/" + registrar
    );
    let templetes: IAPIResponse<IOption[]> = response.data;
    return Promise.resolve(templetes);
  }

  async GetATemplete(
    id: number
  ): Promise<IAPIResponse<ApplicationSMSTempletes>> {
    const response = await axios.get<IAPIResponse>(
      "/admin/templates/sms/getatemplete/" + id
    );
    let templetes: IAPIResponse<ApplicationSMSTempletes> = response.data;
    return Promise.resolve(templetes);
  }

  async UpdateATemplete(
    data: SmsTempleteDto
  ): Promise<IAPIResponse<ApplicationSMSTempletes>> {
    const response = await axios.put<IAPIResponse>(
      "/admin/templates/sms/updatetemplete/",
      data
    );
    let templetes: IAPIResponse<ApplicationSMSTempletes> = response.data;
    return Promise.resolve(templetes);
  }

  async CreateATemplete(
    data: NewSmsTempleteDto
  ): Promise<IAPIResponse<ApplicationSMSTempletes>> {
    const response = await axios.post<IAPIResponse>(
      "/admin/templates/sms/createtemplete/",
      data
    );
    let templetes: IAPIResponse<ApplicationSMSTempletes> = response.data;
    return Promise.resolve(templetes);
  }
}
